import Modal from "react-bootstrap/Modal";
import CustomButton from "../CustomButton";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import RichTextEditor from "../texts/RichTextEditor";
import { AddNewRiskForm } from "./AddNewRisk";
import ModalUI from "../ui/ModalUI";
import ShortTextInput from "../Inputs/ShortTextInput";
import AutoCompleteDropdown from "../Inputs/AutoCompleteDropdown";
import BooleanInput from "../Inputs/BooleanInput";
import TagDropdownInput from "../buttons/TagDropdownInput";
import RiskTaskModal from "./RiskTaskModal";
import LessonTaskModal from "./LessonTaskModal";
import styles from "./CreateUpdateTaskModalUI.module.css";
import Divider from "../common/Divider";
import { BookIcon, CommentIcon, WarningIcon } from "../Icons/common";
import Drawer from "@mui/material/Drawer";
import Backdrop from '@mui/material/Backdrop';
import TaskComments from "../TaskComments";
import { stringToColor } from "../../utils/colorUtils";

// this component is used to create or update a task/goal modals
const CreateUpdateTaskModalUI = ({
  show, // show modal
  handleClose, // close modal
  formik,
  is_new_task, // is new task
  activeStep, // active step in the stepper
  setActiveStep, // set active step
  priorities,
  workStreamData, // work stream data
  workStreamId, // work stream id for hide work stream dropdown
  assignees,
  setAssignees,
  workStreams,
  setWorkStreams,
  handleSubmit, // handle submit function to update or create task
  task, // task details
  is_subtask = false,
  task_id, // this is for add risk(newly created task id)
  customFields,
  risks, //this is for count total risks & show in risk modal
  fetchRisks, //this is for fetching risks when add new risk
  lessons,
  fetchLessons,
  comments,
  fetchComments,
}) => {
  useEffect(() => {
    // Set assignees
    if (task?.assignees && task.assignees.length) {
      const member = workStreamData.members.filter((item) =>
        task.assignees.some((assignee) => assignee.id === item.id)
      );
      setAssignees(member);
    }

    // Set workStreams
    if (task && !is_new_task && task.workStreams && task.workStreams.length) {
      const matchedWorkStreams = workStreamData.initiatives.filter((item) =>
        task.workStreams.some((ws) => ws.id === item.id)
      );
      setWorkStreams(matchedWorkStreams);
    }
  }, [task, is_new_task, workStreamData]);

  // Handle next button click
  const handleNextButton = () => {
    // if the form is not valid, return
    if (
      formik.errors.title ||
      formik.errors.description ||
      formik.errors.due_date ||
      !formik.values.priorities
    ) {
      return;
    }
    handleSubmit(formik.values);
    setActiveStep((prevActiveStep) => (prevActiveStep === 0 ? 1 : 0));
  };

  const [showRiskModal, setShowRiskModal] = useState(false);
  const [showLessonModal,setShowLessonModal]=useState(false);

  const [openComments, setOpenComments] = useState(false);
  const [commentSectionOptions, setCommentSectionOptions] = useState({
    is_sub: false,
    id: task?.id,
    title: "",
  });

  const toggleCommentSection = (is_sub = false, id = 0, title = "") => {
    setCommentSectionOptions((prevOptions) => ({
      ...prevOptions,
      id: id,
      is_sub: is_sub,
      title: title,
    }));
    setOpenComments(!openComments);
  };



  let title = is_subtask ? "Task" : "Goal";
  let prefix = is_new_task ? "Add" : "Update"

   if (activeStep === 1) {
    title = "Risk";
    prefix = "Add";
  }

  return (
    <ModalUI
      show={show}
      handleClose={handleClose}
      size={activeStep === 1 ? "lg" : "xl"}
      zIndex={1050}
      title={
        <div className="flex items-center gap-1 p3 fw-bold">
          {prefix} {title}
           {task?.id && activeStep === 0 && <span className="text-secondary p4"> #{task?.id}</span>}
        </div>
      }
    >
      <form onSubmit={formik.handleSubmit} id="create-update-task-form">
        {/* 
            If this is subtask will show `Add Task` 
            If this is not a subtask & new task will show `Add New Task`
            If this is not a subtask & not a new task will show `Previous lessons you may find helpful`
        */}

       {/* {!is_new_task && <PreviousLessons />} */}

        {/* --------------------------these are form inputs---------------------- */}
        <Modal.Body
           className={activeStep === 1 ? "p-0 m-0" : ""}
            style={{ 
              paddingInline: activeStep === 1 ? "40px" : "0px"
            }}
        >
          {/* if it is a subtask or in stepper step 1 */}
          {(is_subtask || activeStep === 0) && (
            <Row className="gx-0">
              {/* Goal Title */}
              <ShortTextInput
                id="title"
                name="title"
                fullWidth
                containerClassName="mb-3"
                label={`${title} title`}
                value={formik.values.title}
                onChange={formik.handleChange}
                placeholder="Enter goal title"
                error={formik.touched.title && formik.errors.title}
                required
              />

              {/* Left side */}
              <Col xs={12} lg={6} className="pe-lg-3">
                {/* Description */}
                <RichTextEditor
                  editorValue={formik.values.description}
                  required
                  label={`${is_subtask ? "Task" : "Goal"} description`}
                  setEditorValue={(value) =>
                    formik.setFieldValue("description", value)
                  }
                  error={
                    formik.touched.description && formik.errors.description
                  }
                  id="description"
                />

              </Col>

              {/* Right side */}
              <Col xs={12} lg={6} className="ps-lg-3 mt-3 mt-lg-0">
                {/* Date/Time */}
                <ShortTextInput
                  id="due_date" //"2025-03-22T00:00:00Z"
                  type="date"
                  name="due_date"
                  label="Due date"
                  fullWidth
                  value={
                    formik.values.due_date
                      ? new Date(formik.values.due_date)
                          .toISOString()
                          .split("T")[0]
                      : "yyyy-mm-dd" // Shows this text if no date is present
                  }
                  onChange={(e) => {
                    const dateTime = e.target.value;
                    formik.setFieldValue("due_date", dateTime);
                  }}
                  error={formik.touched.due_date && formik.errors.due_date}
                  required
                />

                {/* Priorities */}
                <AutoCompleteDropdown
                  label="Priorities"
                  required
                  className="mt-3"
                  options={priorities}
                  value={formik.values.priorities}
                  error={formik.touched.priorities && formik.errors.priorities}
                  placeholder="Select priority"
                  onChange={(event, value) =>
                    formik.setFieldValue("priorities", value)
                  }
                  id="priorities"
                />

                {/* Assignees */}
                <TagDropdownInput
                  label="Assignees"
                  data={workStreamData?.members}
                  selectedItems={assignees}
                  className="mt-3"
                  onChange={(event, value) => setAssignees(value)}
                  placeholder="Select assignees"
                  id="assignees"
                  error={formik.errors.assignees}
                  helperText={
                    formik.touched.assignees && formik.errors.assignees
                  }
                />

                {/* WorkStreams */}
                {!workStreamId && <TagDropdownInput
                  label="WorkStreams"
                  data={workStreamData?.initiatives}
                  selectedItems={workStreams}
                  className="mt-3"
                  onChange={(event, value) => setWorkStreams(value)}
                  placeholder="Select workstreams"
                  id="workStreams"
                  error={formik.errors.workStreams}
                  helperText={
                    formik.touched.workStreams && formik.errors.workStreams
                  }
                />}
              </Col>

              {/* Custom Fields */}
              {customFields?.length > 0 && (
                // Check if there are any custom fields
                <>
                <Divider />
                <h5 className="p3">Custom Fields</h5>
                <div className="mt-3">
                  {customFields.map((field) => {
                    const commonProps = {
                      id: field.name,
                      name: field.name,
                      label: field.name,
                      value: formik.values[field.name],
                      onChange: formik.handleChange,
                      error: formik.errors[field.name],
                    };

                    const renderInput = () => {
                      switch (field.type.toLowerCase()) {
                        case "text":
                          return <ShortTextInput {...commonProps} placeholder="Enter text here.." />;
                        case "number":
                          return (
                            <ShortTextInput {...commonProps} type="number" placeholder="Enter value here.." />
                          );
                        case "date":
                          return (
                            <ShortTextInput {...commonProps} type="date" />
                          );
                        case "boolean":
                          return (
                            <BooleanInput
                              {...commonProps}
                              onChange={(event) =>
                                formik.setFieldValue(
                                  field.name,
                                  event.target.value
                                )
                              }
                            />
                          );
                        default:
                          return null;
                      }
                    };

                    return (
                      <div key={field.id} className="mb-3">
                        {renderInput()}
                      </div>
                    );
                  })}
                </div>
                </>
              )}
            </Row>
          )}
          {activeStep === 1 && (
            
            <AddNewRiskForm
              handleRiskClose={handleClose}
              task_id={task_id}
              from_goal
            />
          )}
        </Modal.Body>
        

        {/* ---------------related-------------------- */}
        {/* Show only when updating a task */}
        {!is_new_task && task_id && activeStep === 0 && (
          <div className="d-flex flex-row align-items-center mt-3 gap-2 flex-wrap">
            
            <p className="text-secondary m-0">Related:</p>
            {/* Display count of available risks */}
            <CustomButton
              variant="gray-outline"
              onClick={() => setShowRiskModal(true)}
              icon={<WarningIcon variant="triangle" size={20} />}
              >
              Risks - <span className="secondary-box px-2 rounded-5">{risks?.length}</span>
              </CustomButton>

              <CustomButton
              variant="gray-outline"
              onClick={() => setShowLessonModal(true)}
              icon={<BookIcon size={20} />}
              >
              Lessons - <span className="secondary-box px-2 rounded-5">{lessons?.length}</span>
              </CustomButton>
              
              <CustomButton
              variant="gray-outline"
              onClick={() => toggleCommentSection(false, task_id, task?.title || "Task")}
              icon={<CommentIcon size={20} />}
              >
               Comments - <span className="secondary-box px-2 rounded-5">{comments?.length}</span>
              </CustomButton> 
            
          </div>
        )}
        {!is_new_task && task_id && activeStep === 0 && (
          <>
          <RiskTaskModal
            show={showRiskModal}
            handleClose={() => setShowRiskModal(false)}
            task={task}
            task_id={task_id}
            fetchRisks={fetchRisks}
            risks={[...(risks || [])].sort((a, b) => new Date(b.created_at) - new Date(a.created_at))}
          />
          <LessonTaskModal
            show={showLessonModal}
            handleClose={() => setShowLessonModal(false)}
            task={task}
            task_id={task_id}
            fetchLessons={fetchLessons}
            lessons={lessons}
          />
            <Backdrop
    open={openComments}
    onClick={toggleCommentSection}
    sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
    />
        <Drawer
          anchor="right"
          open={openComments}
          onClose={toggleCommentSection}
          classes={{ paper: styles.drawerContent }}
           // Keep the backdrop
          hideBackdrop={false}
           // Use permanent variant to avoid aria-hidden issues
          variant="persistent"
        >
          <TaskComments
            close={toggleCommentSection}
            loadAll={fetchComments} 
            stringToColor={stringToColor}
            options={commentSectionOptions}
          />
        </Drawer> 
         </>

        )}

       {activeStep === 0 && <Divider />}


        {/* Footer */}
        <Modal.Footer className="border-0 p-0">
          {/* 
            If this is subtask will show only `Save`
            If this is not a subtask will show `Save & Add Subtask` and `Next` or `Back`
           */}
          {!is_subtask && activeStep === 0 && (
            <>
              {is_new_task && (
                <CustomButton
                  disabled={formik.isSubmitting}
                  variant="outline"
                  onClick={handleNextButton}
                  type="submit"
                >
                  {activeStep === 0 ? "Add Risk (optional)" : "Back"}
                </CustomButton>
              )}
            </>
          )}
          {(is_subtask || activeStep === 0) && (
            <CustomButton
              disabled={formik.isSubmitting}
              type="submit"
              onClick={() => handleSubmit(formik.values, true)}
            >
              Save {title}
            </CustomButton>
          )}
        </Modal.Footer>
      </form>
    </ModalUI>
  );
};

export default CreateUpdateTaskModalUI;

// PreviousLessons component
const PreviousLessons = () => {
  return (
    <div
      className={`${styles.previousLessons} rounded w-100 d-flex justify-content-between align-items-center gap-3 rounded-4 p-3 mt-2`}
    >
      <div className="d-flex gap-3">
        <div className="w-auto">
        <WarningIcon className={styles.warningIcon} size={24} />
        </div>
        <div className="d-flex flex-column">
          <span className={`${styles.lessonCount} p3`}>
            2 matching lessons found
          </span>
          <span className={`${styles.lessonDescription} p4`}>
            We found some previous lessons learned that might relevant to this
            task.
          </span>
        </div>
      </div>
      <div>
        <CustomButton
          type="button"
          variant="orange-outline"
          onClick={() => {}}
        >
          View Lessons
        </CustomButton>
      </div>
    </div>
  );
};
